export default __webpack_public_path__ + "static/media/Izmir-Medium.160eda95.woff2";